import TextAreaWithCounter from "./TextAreaWithCounter";

export default TextAreaWithCounter;
